"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SIDEBAR_WIDTH = exports.SIDEBAR_MARGIN = void 0;
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
var SIDEBAR_WIDTH = exports.SIDEBAR_WIDTH = 160;
var SIDEBAR_MARGIN = exports.SIDEBAR_MARGIN = 8;
var useStyles = (0, _styles.makeStyles)({
  root: {
    width: SIDEBAR_WIDTH,
    margin: "0 ".concat(SIDEBAR_MARGIN, "px"),
    flexShrink: 0
  },
  fixed: {
    position: "fixed",
    width: SIDEBAR_WIDTH
  },
  actions: {
    margin: "15px 0"
  }
});
var SidePageSidebar = function SidePageSidebar(_ref) {
  var children = _ref.children,
    actions = _ref.actions;
  var classes = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: classes.root,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: classes.fixed,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: classes.actions,
        children: actions
      }), children]
    })
  });
};
var _default = exports["default"] = SidePageSidebar;